import { Modal } from "antd";
import { DesignProduct } from "../../util/Products";
import "./CreateDesignModal.scss";
import CreateDesignMenuContent from "./CreateDesignMenuContent";
import { CloseOutlined } from "@ant-design/icons";
import { MenuFolderDto } from "../../generated/dashboard-client";

export interface CreateDesignModalProps {
	isVisible: boolean;
  products: DesignProduct[];
	onClose: () => void;
	activeFolder: MenuFolderDto | null;
}

export default function CreateDesignModal({products, isVisible, onClose, activeFolder} : CreateDesignModalProps) {
	return (
		<Modal
			className={"clean one create-design-modal"}
			visible={isVisible}
			onCancel={onClose}
		>
			<div className={"modal-title"}>
				Create a design
				<span onClick={onClose}><CloseOutlined/></span>
			</div>
			<CreateDesignMenuContent products={products} activeFolder={activeFolder} />
		</Modal>
  )
}